var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_1",
    "data-name": "\\uB2E4\\uAC01\\uD615 1",
    transform: "translate(28) rotate(90)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.12952041625977 26.5 L 8.870479583740234 26.5 L 1.727622866630554 13.99999904632568 L 8.870479583740234 1.499999046325684 L 23.12952041625977 1.499999046325684 L 30.27237701416016 13.99999904632568 L 23.12952041625977 26.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.740970611572266 2.999998092651367 L 3.455255508422852 13.99999904632568 L 9.740970611572266 25 L 22.25902938842773 25 L 28.54474449157715 13.99999904632568 L 22.25902938842773 2.999998092651367 L 9.740970611572266 2.999998092651367 M 8 -1.9073486328125e-06 L 24 -1.9073486328125e-06 L 32 13.99999904632568 L 24 28 L 8 28 L 0 13.99999904632568 L 8 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.e22bc6993b63ae316c33c3b6ef22d420.svg";
export { ForwardRef as ReactComponent };